<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="line"></div>
            <validation-observer v-slot="{ invalid }">
                <div class="infoWrap">
                    <div class="headLogo bh bstart">
                        <span class="fz_30 c_333 logoText">油卡机构</span>
                        <div class="oilLogo ico-oilLogo bg-contain"></div>
                    </div>
                    <div class="cardInfo">
                        <validation-provider name="油卡卡号" rules="required|oil" v-slot="{ errors }">
                            <van-field
                                clearable
                                label-width="5em"
                                label="油卡卡号"
                                maxlength="19"
                                v-model="formData.number"
                                placeholder="请输入以100011开头共19位的主卡卡号"
                            >
                                <zb-warning slot="right-icon" :message="errors[0]" />
                            </van-field>
                        </validation-provider>
                        <validation-provider
                            name="姓名"
                            rules="name|max:10|required"
                            v-slot="{ errors }"
                        >
                            <van-field
                                label-width="5em"
                                clearable
                                maxlength="10"
                                label="姓名"
                                v-model="formData.ownerName"
                                placeholder="请输入持卡人姓名"
                            >
                                <zb-warning slot="right-icon" :message="errors[0]" />
                            </van-field>
                        </validation-provider>
                    </div>
                </div>
                <div class="warnWrap bh fz_24 c_999">
                    <van-icon name="warning-o" class="warnIco c_red" />
                    <div class="b1">请认真核对您的主卡卡号，卡号错误造成的损失责任自行承担，不支持副卡充值</div>
                </div>
                <div class="xBtn-wrap">
                    <van-button
                        :disabled="invalid"
                        size="large"
                        class="logBtn btn btn-submit-big"
                        @click="onSaveClick"
                    >确认添加</van-button>
                </div>
            </validation-observer>
        </div>
    </div>
</template>
<script>
import { addOilCard } from "@/api/fee";
import { user } from "@/mixin/user";
export default {
    mixins: [user],
    name: "FeeOilEdit",
    data() {
        return {
            formData: {
                number: "",
                ownerName: "",
                // 0 中石化 1 中石油
                type: "0"
            }
        };
    },
    created() {
        const me = this;
        // 测试环境处理
        if (me.$store.state.isDev) {
            me.formData.number = "1000111234567890432";
            me.formData.ownerName = "赵修瞾";
        }
    },
    methods: {
        onSaveClick() {
            const me = this;
            addOilCard(me.formData).then(res => {
                // 刷新油卡列表，
                // 取消添加或者从添加页面返回
                me.$store.dispatch("fee/oilCardList", true);
                // 设置当前选中油卡id
                me.$store.state.fee.oilCardId = res.data;
                // 返回上一页
                me.backGo();
            });
        }
    }
};
</script>
<style scoped lang="scss">
.topbar-container {
    background-color: #f7f8f8;
    .infoWrap {
        padding: 0 40px;
        background-color: #fff;
        .oilLogo {
            height: 90px;
            width: 200px;
        }
        .headLogo {
            padding: 40px 0;
            .logoText {
                margin-right: 26px;
            }
        }
        /deep/ .van-cell {
            padding: 40px 0;
            border-top: 1px solid #dcdcdc;
        }
    }
    .warnWrap {
        padding: 40px 30px 0 30px;
        .warnIco {
            margin: 5px 10px 0 0;
        }
    }
    .xBtn-wrap {
        padding: 170px 120px 0px;
    }
}
</style>